import styled from 'styled-components';

export const Wrapper = styled.div`
  /* flex-grow: 1; */
  height: 100%;
  width: 100%;
  position: relative;
  background-color: #f9fbff;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    display: none;
  }

  @media print {
    display: block !important;
    overflow-y: visible !important;
    width: 100%;
  }
`;

export const DisclaimerWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledDisclaimer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
`;
